import { computeSelectedKeys } from "@/lib/pageSelection";

/**
 * Floating toolbar shown when the user has selected a range of ayahs.
 * Handles the visual chrome only — all action logic (play/memorize/bookmark)
 * is passed in via callbacks.
 */
export default function PageSelectionToolbar({
  selection,
  pageAyahs,
  onClear,
  onPlayRange,
  onMemorizeRange,
  onBookmarkRange,
  isAllMemorized,
}) {
  const keys = computeSelectedKeys(pageAyahs, selection);
  if (!keys || keys.size === 0) return null;
  return (
    <div
      data-testid="page-selection-toolbar"
      className="mb-3 flex items-center justify-center gap-3 px-4 py-2 rounded-full bg-[#1B4D3E]/95 border border-[#C9A227]/40 shadow-lg text-[#E8D5A3] font-outfit text-sm w-fit mx-auto"
    >
      <span data-testid="page-selection-count">
        {keys.size} ayah{keys.size === 1 ? "" : "s"} selected
      </span>
      <button
        data-testid="page-selection-play-btn"
        onClick={onPlayRange}
        className="px-3 py-1 rounded-full bg-[#C9A227] text-[#0D2818] hover:bg-[#E8C75B] transition-colors text-xs font-semibold"
      >
        ▶ Play range
      </button>
      <button
        data-testid="page-selection-memorize-btn"
        onClick={onMemorizeRange}
        disabled={isAllMemorized}
        className="px-3 py-1 rounded-full border border-[#C9A227]/60 text-[#E8D5A3] hover:bg-[#C9A227]/15 transition-colors text-xs disabled:opacity-50 disabled:cursor-not-allowed"
        title={
          isAllMemorized
            ? "All selected ayahs are already memorized"
            : "Loop selection in Stack Mode and mark all as memorized"
        }
      >
        ✓ Memorize range
      </button>
      <button
        data-testid="page-selection-bookmark-btn"
        onClick={onBookmarkRange}
        className="px-3 py-1 rounded-full border border-[#C9A227]/60 text-[#E8D5A3] hover:bg-[#C9A227]/15 transition-colors text-xs"
        title={
          keys.size === 1
            ? "Bookmark this ayah"
            : `Bookmark ${keys.size} ayahs with a shared note`
        }
      >
        ☆ Bookmark range
      </button>
      <button
        data-testid="page-selection-clear-btn"
        onClick={onClear}
        className="text-[#C9A227]/80 hover:text-[#E8C75B] text-xs"
      >
        Clear
      </button>
    </div>
  );
}
